import React from 'react';

export default function LoadingSixAnims() {
	return (
		<>
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
		</>
	);
}

export function LoadingSkeleton() {
	return (
		<div className="flex animate-pulse items-center mb-10 justify-start ml-[3%] flex-col w-[30%] aspect-[16/10]">
			<div className="w-full aspect-[16/10] bg-gray-300 rounded-md "></div>
			<div className="w-1/2 mt-3">
				<div className="w-10/12 bg-gray-300 h-6 rounded-md "></div>
			</div>
		</div>
	);
}
